// @flow

/**
 * Takes a localized numeric string and removes any
 * characters besides the numbers and dec. separator
 * "1,234.56" => "1234.56"
 *
 * @param {string} amount Any amount string such as "1,234.56"
 * @param {string} separator the decimal separator ("." or ",")
 * @returns {string} A stripped down string such as "1234.56"
 */
export function stripInvalid(
  amount: string = '',
  separator: CurrencySeparator = '.'
) {
  return amount.replace(new RegExp(`[^\\${separator}0-9]`, 'g'), '')
}

export function getNumericValue(
  value: string,
  currencyDecimal: string
): number {
  return parseFloat(
    (value || '')
      .replace(new RegExp(`[^\\d\\${currencyDecimal}]`, 'g'), '')
      .replace(currencyDecimal, '.')
  )
}

export function isZero(value: string, currencyDecimal: string): boolean {
  return getNumericValue(value, currencyDecimal) === 0
}

export function moveDecimal(num: number, decimals: number = 0): number {
  return num / Math.pow(10, decimals)
}

export function getNonZeroValue(
  value: string,
  currencyDecimal: string
): string {
  return isZero(value, currencyDecimal) ? '' : value
}
